/**
 * Converts a file to base64 string.
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Validates if the selected file is an image.
 */
export const validateImageFile = (
  file: File,
  maxFileSize?: number,
  setError?: (error: string) => void
): boolean => {
  if (!file.type.startsWith('image/')) {
    if (setError) {
      setError('Please select a valid image file.');
    }
    return false;
  }

  if (maxFileSize && file.size > maxFileSize) {
    if (setError) {
      setError(
        `File size must be less than ${maxFileSize / 1024 / 1024}MB. You uploaded a file of ${(file.size / 1024 / 1024).toFixed(2)}MB.`
      );
    }
    return false;
  }

  return true;
};
